import { AbstractControl, ValidationErrors } from '@angular/forms';

export const validateEmail = (value: string): boolean => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);

const EmailValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const value = formControl && (formControl.value as string);

  if (!value) {
    return {};
  }

  const email = !validateEmail(value);

  if (!email) {
    return {};
  }

  return { email };
};

export default EmailValidator;
